@if (folder(); as item) {
  <div
    class="folder-drop-target relative flex h-full min-h-0 flex-col"
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="canDrop"
    [appDroppableDisabled]="item.deleted || item.archived || store.busy() || store.dirty() || store.folderCopyPending()"
    (appDroppableDrop)="drop($event)"
  >
    <div class="drop-area-border" aria-hidden="true"></div>
    <div class="skin-detail-heading flex shrink-0 items-center gap-4">
      <app-input
        class="min-w-0 flex-1"
        appearance="sapphire-inline"
        size="s"
        placeholder="New Folder"
        [inputFormControl]="form.controls.title"
        [disabled]="item.deleted || store.busy() || store.folderCopyPending()"
      />
      <app-button2
        appearance="secondary-ghost"
        size="xs"
        [ariaLabel]="item.archived ? 'Restore from archive' : 'Archive'"
        [disabled]="store.busy() || store.dirty() || store.folderCopyPending() || item.deleted"
        (click)="archive()"
        ><app-icon name="sapphire-archive" size="s"
      /></app-button2>
      <app-button2
        appearance="secondary-ghost"
        size="xs"
        [ariaLabel]="item.deleted ? 'Restore from trash' : 'Trash'"
        [disabled]="store.busy() || store.dirty() || store.folderCopyPending()"
        (click)="trash()"
        ><app-icon name="sapphire-trash" size="s"
      /></app-button2>
      <app-button2
        appearance="secondary-ghost"
        size="xs"
        ariaLabel="More"
        [appFormFolderContextMenu]="item"
        appFormFolderContextMenuMode="popover"
        (appFormFolderContextMenuOpen)="openFolderMenu($event)"
        [disabled]="store.busy() || store.dirty() || store.folderCopyPending() || store.folderActivity()"
        ><app-icon name="sapphire-ellipsis" size="s"
      /></app-button2>
      <app-button2
        appearance="secondary-ghost"
        size="xs"
        ariaLabel="Close folder"
        [disabled]="store.busy() || store.folderActivity()"
        (click)="close()"
        ><app-icon name="sapphire-close" size="s"
      /></app-button2>
    </div>
    <div class="shrink-0 pb-7">
      <app-stitch-timestamps
        class="flex min-h-[24px] items-center"
        [createdAt]="item.createdAt"
        [updatedAt]="item.updatedAt"
      />
    </div>
    <div class="skin-detail-tabs !mt-0 flex h-[42px] shrink-0 items-center gap-4 border-b border-gray-200 px-8">
      <app-tabs
        class="min-w-0 flex-1"
        appearance="sapphire"
        size="m"
        [values]="tabs"
        [value]="tab()"
        (valueChange)="selectTab($event)"
      /><stch-knowledge-button [active]="displayKnowledge()" (click)="toggleKnowledge()" />
    </div>
    @if (tab() === 'stitch' && hasKnowledgeHubAccess()) {
      <app-entity-hub-search [contactId]="item.id" />
    }
    <app-form-knowledge
      [class.hidden]="!displayKnowledge() || (tab() === 'stitch' && !hasKnowledgeHubAccess())"
      [item]="item"
      [hubMode]="tab() === 'stitch' && hasKnowledgeHubAccess()"
    />

    @if (store.folderCopyPending()) {
      <section class="px-8 py-4" role="status">
        <span>{{ store.folderCopyProgress() }}</span
        ><app-button2 appearance="secondary" size="s" [disabled]="store.busy()" (click)="store.duplicateFolder()"
          >Retry folder copy</app-button2
        >
      </section>
    }
    <div
      class="min-h-0 flex-1"
      [class.overflow-y-auto]="!(tab() === 'stitch' && hasKnowledgeHubAccess())"
      [class.overflow-hidden]="tab() === 'stitch' && hasKnowledgeHubAccess()"
    >
      @switch (tab()) {
        @case ('forms') {
          <div class="flex h-full flex-col bg-offwhite">
            <ng-container [ngTemplateOutlet]="contents()" />
          </div>
        }
        @case ('details') {
          <div class="flex flex-wrap gap-8 p-8">
            <span>Description</span
            ><app-editable-textarea
              class="w-full max-w-[340px]"
              appearance="sapphire-outline"
              placeholder="Description"
              [inputFormControl]="form.controls.description"
              [disabled]="item.deleted || store.busy() || store.folderCopyPending()"
              [withClear]="true"
            />
          </div>
        }
        @case ('stitch') {
          <div
            class="h-full"
            appDroppable
            appDroppableHoverClass="drag-over"
            [appDroppablePredicate]="canStitch"
            [appDroppableDisabled]="item.deleted || store.busy() || store.folderCopyPending() || store.dirty()"
            (appDroppableDrop)="stitchDrop($event)"
          >
            @if (permissionsLoaded()) {
              @if (hasKnowledgeHubAccess()) {
                <app-stitch-hub
                  class="h-full"
                  [stitch]="item"
                  [withUnlink]="!item.deleted"
                  [withUnlinkAll]="!item.deleted"
                  [unlinkParentPairsOnly]="true"
                  (clickStitchItem)="openItem($event)"
                  (dblClickStitchItem)="openItem($event)"
                />
              } @else {
                <app-linked-info-list
                  class="block p-8"
                  [stitch]="item"
                  [withUnlink]="!item.deleted"
                  [withUnlinkAll]="!item.deleted"
                  [unlinkParentPairsOnly]="true"
                  (clickStitchItem)="openItem($event)"
                  (dblClickStitchItem)="openItem($event)"
                />
              }
            }
          </div>
        }
      }
      @if (visited().has('comments')) {
        <div class="block p-8" [hidden]="tab() !== 'comments'">
          <stch-comments
            [stitch]="item"
            [readOnly]="!!item.deleted"
            [active]="tab() === 'comments'"
            [fenceCompletion]="true"
          />
        </div>
      }
      <div [hidden]="tab() !== 'attachments'">
        <app-form-attachments [active]="tab() === 'attachments'" [item]="item" (workChanged)="store.folderActivity.set($event.busy)" />
      </div>
    </div>
    <stch-save-cancel-panel
      [enabled]="store.dirty() && !item.deleted"
      [uploading]="store.busy() || store.folderActivity()"
      (onSave)="save()"
      (onCancel)="store.cancelFolderChanges()"
    />
    <div
      class="flex h-[49px] shrink-0 items-center justify-between gap-3 border-t border-gray-200 bg-offwhite px-4 text-[10px] text-[#637791]"
      data-testid="form-record-footer"
    >
      <nav class="form-breadcrumbs flex min-w-0 flex-1 items-center text-[12px]" aria-label="Breadcrumb">
        <ol class="m-0 flex min-w-0 list-none items-center gap-2 p-0">
          <li class="flex shrink-0 items-center gap-2">
            <app-button2 appearance="secondary-ghost" size="xs" (click)="store.selectView('all')">Forms app</app-button2>
          </li>
          <li class="flex min-w-0 items-center gap-2">
            <app-icon class="shrink-0" name="sapphire-chevron-right" [size]="14" aria-hidden="true" /><span
              class="min-w-0 truncate text-[#0f1f33]"
              aria-current="page"
              data-testid="breadcrumb-title"
              >{{ item.title }}</span
            >
          </li>
        </ol>
      </nav>
    </div>
  </div>

}
